module.exports = __webpack_public_path__ + "img/action-like.7bec8e44.svg";